import React, { useState } from "react";
import { Link } from "react-router-dom";
import useAuth from "../../../Hooks/useAuth";
import MainButton from "../MainButton/MainButton";
import Paragraph from "../Typography/Paragraph";
import AuxiliaryText from "../Typography/AuxiliaryText";
import SpecialText from "../Typography/SpecialText";
import { useStripe } from '@stripe/react-stripe-js';
import { useGraphQL } from "../../../context/GraphQLProvider";
import { CreateCheckoutSessionMutation } from "../../../services/StripeService";
import Alerts from "../Alerts/Alerts";

const PriceCard = ({
  MainDiveClasses,
  tagging,
  tag,
  label,
  price,
  description,
  buttonText,
  listItems,
  listItemsValue,
  upgradePackageHandler,
  pricingColor,
  bottomLine,
  listClasses,
  currentPlan,
  planId
}) => {
  const { auth } = useAuth();
  const stripe = useStripe();
  const graphqlService = useGraphQL();
  const [isLoading, setIsLoading] = useState(false);

  const handleCheckout = async () => {
    try {
      setIsLoading(true);
      const response = await CreateCheckoutSessionMutation(graphqlService, {
        input: {
          userId: auth?.user,
          planId: planId,
          // successUrl: `${window.location.origin}/checkout/success?session_id={CHECKOUT_SESSION_ID}`,
          // cancelUrl: `${window.location.origin}/pricing`
        }
      });

      if (response?.createCheckoutSession?.url) {
        // Alerts.success('Redirecting to checkout...');
        window.location.href = response.createCheckoutSession.url;
      } else if (response?.createCheckoutSession?.id) {
        // Alerts.success('Redirecting to checkout...');
        const result = await stripe.redirectToCheckout({
          sessionId: response.createCheckoutSession.id,
        });

        if (result.error) {
          Alerts.error(result.error.message);
        }
      }
    } catch (error) {
      console.error('Error:', error);
      Alerts.error('Failed to initiate checkout. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className={`rounded-xl p-8 transition-transform duration-300 hover:scale-105 ${MainDiveClasses}`}
      >
        <div className="flex items-center justify-between h-[20px]">
          <div>
            <AuxiliaryText variant={"Eyebrow"}>{label}</AuxiliaryText>
          </div>
          {currentPlan && (
            <div className="bg-primaryblue text-white px-[4px] py-[1px] rounded-[4px]">
              <AuxiliaryText variant={"Infographic"}>Current Plan</AuxiliaryText>
            </div>
          )}
          {!tagging && (
            <div className="bg-primaryblue text-white px-[4px] py-[1px] rounded-[4px]">
              <AuxiliaryText variant={"Infographic"}>Popular</AuxiliaryText>
            </div>
          )}
        </div>
        <div className="flex h-fit">
          <SpecialText
            variant={"number-xl"}
            className={`${pricingColor}`}
          >
            {/* $00 */}
            ${price}
          </SpecialText>
          <sub className="ml-1 mt-auto mb-6">
            <SpecialText variant={"Date"}>/&nbsp; month</SpecialText>
          </sub>
        </div>
        <div className={`mt-3 sm:mt-5 ${bottomLine}`}>
          <Paragraph
            variant={"BodyCompact"}
            className={"w-full h-[40px] xs:h-[59px] sm:h-[65px] lg:h-[41px] xl:h-[42px] 2xl:h-[46px] overflow-hidden text-ellipsis text-offblack"}
          >
            {description}
          </Paragraph>
        </div>
        <div className={`pt-4 ${listClasses}`}>
          <ul>
            {listItems.map((item, index) => {
              return (
                <li
                  key={index}
                  className="flex items-center h-4capitalize mt-1 sm:mt-3"
                >
                  <i className="fi fi-rs-check text-sm text-primaryblue mr-5 my-auto"></i>
                  <Paragraph variant={"BodyDense"} className="whitespace-nowrap">
                    {item.trim()}
                  </Paragraph>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="flex justify-center sticky top-[100%]">
          {currentPlan ? (
            <MainButton
              type="button"
              variant={"extralarge"}
              disabled={true}
              className="opacity-50 cursor-not-allowed"
            >
              Current Plan
            </MainButton>
          ) : (
            <MainButton
              type="button"
              variant={"extralarge"}
              onClick={handleCheckout}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : buttonText}
            </MainButton>
          )}
        </div>
      </div>
    </>
  );
};

export default PriceCard;
